import { hapticFeedback } from '@tma.js/sdk-react'
import { useRef } from 'react'
import { useDevToolsStore } from 'shared/store/devtools'

/** Max pause between taps before the counter resets. */
const TAP_GAP_MS = 800
const UNLOCK_TAPS = 20
const REOPEN_TAPS = 2

/** Check if the dev_mode cookie is present in document.cookie. */
function hasDevCookie(): boolean {
	return document.cookie.split(';').some((c) => {
		const [name, ...rest] = c.trim().split('=')
		return name === 'dev_mode' && rest.join('=').trim().length > 0
	})
}

/**
 * Returns an onClick handler for the hidden dev-tools trigger:
 * 20 taps unlock the panel on this device (with passcode gate when no cookie),
 * 2 taps re-open it afterwards.
 */
export function useDevTap() {
	const taps = useRef(0)
	const lastTap = useRef(0)

	return () => {
		const now = Date.now()
		if (now - lastTap.current > TAP_GAP_MS) taps.current = 0
		lastTap.current = now
		taps.current++

		const { unlocked, unlock, setSheetOpen, setPasscodeModalOpen } =
			useDevToolsStore.getState()
		if (taps.current < (unlocked ? REOPEN_TAPS : UNLOCK_TAPS)) return

		taps.current = 0

		if (!unlocked) {
			if (hasDevCookie()) {
				// Cookie present — skip passcode, unlock directly.
				unlock()
				setSheetOpen(true)
			} else {
				// No cookie — show passcode modal.
				setPasscodeModalOpen(true)
			}
		} else {
			setSheetOpen(true)
		}

		try {
			hapticFeedback.impactOccurred('medium')
		} catch {
			// Not available outside Telegram; ignore.
		}
	}
}
